// Включение web-push уведомлений (подписка через VAPID).
const API_BASE = process.env.REACT_APP_API_URL || "/api";

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export function pushSupported(): boolean {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export async function enablePushNotifications(): Promise<{ ok: boolean; message: string }> {
  if (!pushSupported()) {
    return { ok: false, message: "Уведомления не поддерживаются этим браузером" };
  }
  const token = localStorage.getItem("token");
  if (!token) return { ok: false, message: "Сначала войдите в систему" };

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    return { ok: false, message: "Разрешение на уведомления не выдано" };
  }

  try {
    const reg = await navigator.serviceWorker.ready;

    const keyResp = await fetch(`${API_BASE}/push/vapid-public-key`);
    const keyData = await keyResp.json();
    const publicKey: string = keyData?.public_key || "";
    if (!publicKey) {
      return { ok: false, message: "Push ещё не настроен на сервере (нет VAPID-ключа)" };
    }

    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });
    }

    const resp = await fetch(`${API_BASE}/push/subscribe`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify(sub.toJSON()),
    });
    if (!resp.ok) return { ok: false, message: "Не удалось сохранить подписку" };

    return { ok: true, message: "Уведомления включены ✅" };
  } catch (e: any) {
    return { ok: false, message: `Ошибка: ${e?.message || e}` };
  }
}

// Тихо переподписаться при старте, если разрешение уже выдано (подписка может протухнуть).
export async function autoResubscribePush(): Promise<void> {
  try {
    if (!pushSupported()) return;
    if (Notification.permission !== "granted") return;
    if (!localStorage.getItem("token")) return;
    await enablePushNotifications();
  } catch {
    /* ignore */
  }
}
